import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { getaccountReviewURL, getCustomerAccountReviewURL, getInvoiceURL } from '../api';
import moment from 'jalali-moment'
import { addComma, removeComma } from "../helpers/mmg";

// initial state
export const initialState = {
  loading: false,
  error: false,
  currentPageIndex : 0,
  hasMore : true,
  items: [],
  searchKey_fromdate : '',
  searchKey_todate : '',
  searchKey : '',
  searchKey_debit : 1,
  searchKey_credit : 1,
  fetchPermission : true,//برای مواقعی که بک زده میشه از یک فاکتور به فهرست نمیخواهیم مجدد لود شود

  //selectedInvoice : {},
  //selectedInvoiceId : '',

  //searchKey : '',
  //searchKey_fromdate : '',
  //searchKey_todate : ''
};

// our slice
const accountReviewSlice = createSlice({
  name: "accountReview",
  initialState,
  reducers: {
    setAccountReviewsearchKeyFromdate : (state, { payload }) =>{
      state.searchKey_fromdate = payload;
    },
    setAccountReviewsearchKeyTodate : (state, { payload }) =>{
      state.searchKey_todate = payload;
    },
    setAccountReviewsearchKey : (state, { payload }) =>{
      state.searchKey = payload;
    },
    setAccountReviewsearchKeyDebit : (state, { payload }) =>{
      state.searchKey_debit = payload;
    },
    setAccountReviewsearchKeyCredit : (state, { payload }) =>{
      state.searchKey_credit = payload;
    },
    setAccountReviewsearchKeyType : (state, { payload }) =>{
      state.searchKey_type = payload;
    },
    setAccountReviewLoading: (state) => {
      state.loading = true;
    },
    setAccountReviewItems: (state, { payload }) => {
      state.loading = false;
      state.error = false;
      state.items.push(...payload.data);
      console.log(payload);
      console.log(payload);
      var currentcA = parseFloat(removeComma(payload.customerRemainAmount).replace("(","").replace(")",""));

      if(state.currentPageIndex === 0){
        //console.log("JJJJJJJJJJ");
       
        //var firstRunningValue = parseFloat(removeComma(state.items[0].RunningValue).replace("(","").replace(")",""));
      
        //console.log(firstRunningValue);
        //state.items[0].RunningValue =  currentcA < 0 ? "(" + addComma((currentcA).toString().replace("-","")) + ")" : addComma((currentcA).toString()) ;
      }
      for(var t = 0; t < state.items.length ; t++){
        if(t === 0){
          state.items[t].RunningValue =  currentcA < 0 ? "(" + addComma((currentcA).toString().replace("-","")) + ")" : addComma((currentcA).toString()) ;
        }else{

          let sum = state.items.slice(0, t).reduce((a , b)=> b.Credit > 0 ? (-1 * b.Credit) + a : b.Debit + a , 0);
          console.log("sum " + sum);
          var crv = sum;
          console.log(currentcA.toString() + " - " + crv.toString());
          state.items[t].RunningValue =  currentcA - crv < 0 ? "(" + addComma((currentcA - crv).toString().replace("-","")) + ")" : addComma((currentcA - crv).toString()) ;
        }
      }
      if(payload.data.length === 0){
        state.hasMore = false;
      }
      console.log("newItems count is " + (payload.length));
      state.currentPageIndex++;
    },
    setAccountReviewError: (state) => {
      state.error = true;
    },
    clearAccountReviewItems: (state) => {
      state.items = [];
      state.currentPageIndex = 0;
    },
    clearAccountReviewData: (state) => {
      
      state.loading = false;
      state.error = false;
      state.currentPageIndex = 0;
      state.items = [];
      state.hasMore = true;
      state.fetchPermission = true;
      state.searchKey = '';
      state.searchKey_debit = 1;
      state.searchKey_credit = 1;
      state.searchKey_fromdate = '';
      state.searchKey_todate = '';

    },
    clearAccountReviewFilters: (state) => {
      state.searchKey = '';
      state.searchKey_debit = 1;
      state.searchKey_credit = 1;
      state.searchKey_fromdate = '';
      state.searchKey_todate = '';

    },
  },
});

// export the actions
export const { setAccountReviewsearchKeyFromdate, setAccountReviewsearchKeyTodate,setAccountReviewLoading,
  setAccountReviewsearchKey,setAccountReviewsearchKeyDebit,setAccountReviewsearchKeyCredit, setAccountReviewsearchKeyType,
  setAccountReviewItems, setAccountReviewError, clearAccountReviewData, clearAccountReviewItems, clearAccountReviewFilters} = accountReviewSlice.actions;

// export the selector (".items" being same as in slices/index.js's "items: something")
export const accountReviewItemsSelector = (state) => state.items;

// export the default reducer
export default accountReviewSlice.reducer;


// fetch all items
export function fetchAccountReview(input) {
  return async (dispatch) => {
    console.log("input");
console.log(input);

    var _fd = "";
    _fd = moment.from(input.fromdate, 'fa', 'YYYY/MM/DD')._i.toString().slice(0,10);
    
    var _td = "";
    _td = moment.from(input.todate, 'fa', 'YYYY/MM/DD')._i.toString().slice(0,10);

    if(input.pageindex === 0)
      dispatch(clearAccountReviewItems());

    if(input.hasMore){
      dispatch(setAccountReviewLoading());
      await axios.post(getCustomerAccountReviewURL()+'?withPaging=true&searchKey='+input.searchKey +'&type='+(input.searchKey_credit === 2 ? 1 : (input.searchKey_debit === 2 ? 2 : null))+'&pageIndex='+input.pageindex+'&fromDate='+_fd+'&toDate='+_td+'&username='+input.authUser.username + '&password='+encodeURIComponent(input.authUser.password)+'&token='+input.authUser.token)
      .then(response => {
        console.log("fetchAccountReview"); 
        console.log(response); 
          dispatch(setAccountReviewItems({data : response.data , customerRemainAmount : input.customerRemainAmount}));
      }).catch(function (err) {
        dispatch(setAccountReviewError());
      }).finally(()=> {

      });
  }
  };
}


export function clearAccountReview() {
  return async (dispatch) => {

      dispatch(clearAccountReviewData());
   
  };
}